import { render } from "./ReceiverAddressCard.vue?vue&type=template&id=e6990528&ts=true"
import script from "./ReceiverAddressCard.vue?vue&type=script&lang=ts"
export * from "./ReceiverAddressCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__